//cookies
export const RECEIVE_COOKIES_DATA = "RECEIVE_COOKIES_DATA";
export const CLEAR_COOKIES_DATA = "CLEAR_COOKIES_DATA";

export const RECEIVE_COOKIES_SETTINGS = "RECEIVE_COOKIES_SETTINGS";
export const CLEAR_COOKIES_SETTINGS = "CLEAR_COOKIES_SETTINGS";